const initialState = {
    dietaries: [],
    guest: null,
};

export default function (state = initialState, action) {
    const {payload, type} = action

    switch (type) {
        case "LOAD_GUEST": 
            return {
                ...state,
                guest: {...payload}
            }

        case "LOAD_DIETARIES":
            return {
                ...state,
                dietaries: payload,
            };

        default:
            return {...state};
    }
}
